import React from 'react';
import { Result, Button } from 'antd';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

const NotFoundPage = ({ history }) => {
  const onHome = () => history.push('/events');

  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={
        <Button type="primary" onClick={onHome}>
          Back Home
        </Button>
      }
    />
  );
};

NotFoundPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(NotFoundPage);
